import { LocationData } from "@/components/locations/LocationPage";

export const locations: LocationData[] = [
  {
    slug: "johannesburg",
    city: "Johannesburg",
    province: "Gauteng",
    // Consolidated to /areas/johannesburg hub (richer content + suburbs).
    canonicalTo: "/areas/johannesburg",
    noindex: true,
    metaTitle: "Bookkeeping Services Johannesburg | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping services in Johannesburg. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R300/month.",
    heroTitle: "Bookkeeping Services in Johannesburg",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Johannesburg businesses. From startups in Sandton to SMEs in Soweto — we handle your books so you can focus on growth.",
    intro: "Johannesburg is the economic powerhouse of South Africa, home to the JSE and thousands of thriving businesses. Whether you're running a consultancy in Sandton, a retail business in Rosebank, or a manufacturing operation in the south, staying on top of your bookkeeping and SARS obligations is critical to your success.",
    localInsight: "As Gauteng's business hub, Johannesburg businesses face unique compliance pressures — from B-BBEE reporting requirements to managing multi-branch operations. Our team understands the fast-paced JHB business environment and delivers accurate, timely bookkeeping that keeps you ahead of deadlines.",
    whyLocal: [
      "Deep understanding of Gauteng's business landscape",
      "Experience with diverse industries across Johannesburg",
      "Remote service — no traffic, no wasted time",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "cape-town",
    city: "Cape Town",
    province: "Western Cape",
    canonicalTo: "/areas/cape-town",
    noindex: true,
    metaTitle: "Bookkeeping Services Cape Town | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping services in Cape Town. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R300/month.",
    heroTitle: "Bookkeeping Services in Cape Town",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Cape Town businesses. From tech startups in Woodstock to hospitality in the V&A — we keep your finances in order.",
    intro: "Cape Town's diverse economy spans tech, tourism, agriculture, and creative industries. Whether you're a startup in the Woodstock tech corridor, a wine estate in Stellenbosch, or a hospitality business along the Atlantic Seaboard, professional bookkeeping ensures you stay compliant and profitable.",
    localInsight: "The Western Cape's seasonal tourism industry and growing tech sector create unique bookkeeping challenges — from managing seasonal cash flow to handling foreign client invoicing. We provide consistent, reliable financial administration tailored to Cape Town's dynamic business environment.",
    whyLocal: [
      "Understanding of Western Cape's seasonal industries",
      "Experience with tech, tourism & creative businesses",
      "Remote service — available across the Cape",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "durban",
    city: "Durban",
    province: "KwaZulu-Natal",
    canonicalTo: "/areas/durban",
    noindex: true,
    metaTitle: "Bookkeeping Services Durban | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping services in Durban. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R300/month.",
    heroTitle: "Bookkeeping Services in Durban",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Durban businesses. From logistics at the port to retail in Umhlanga — we manage your financial admin with precision.",
    intro: "Durban is South Africa's busiest port city and a major hub for manufacturing, logistics, and trade. Businesses in eThekwini face complex supply chain finances, import/export documentation, and stringent compliance requirements that demand professional bookkeeping support.",
    localInsight: "KwaZulu-Natal's strong manufacturing and shipping sectors require meticulous financial record-keeping, especially for businesses dealing with customs and international trade. Our team delivers the accuracy and consistency that Durban's industrious business community demands.",
    whyLocal: [
      "Experience with trade, logistics & manufacturing businesses",
      "Understanding of KZN's business regulations",
      "Remote service — Durban, Umhlanga, Pietermaritzburg & beyond",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "pretoria",
    city: "Pretoria",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Pretoria | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping services in Pretoria. Monthly bookkeeping, payroll, SARS compliance, tax returns & CIPC annual returns. SAICA registered. Packages from R300/month.",
    heroTitle: "Bookkeeping Services in Pretoria",
    heroDescription: "SAICA registered bookkeeping, payroll, and SARS compliance services for Pretoria businesses. From government contractors in Centurion to professionals in Hatfield — your books are in safe hands.",
    intro: "As South Africa's administrative capital, Pretoria is home to a thriving economy driven by government services, education, automotive manufacturing, and professional services. Businesses here need reliable bookkeeping that meets the exacting standards expected in the capital.",
    localInsight: "Many Pretoria businesses work with government contracts that require impeccable financial records and compliance documentation. Our team ensures your books are always audit-ready, your SARS submissions are on time, and your financial reporting meets the highest standards.",
    whyLocal: [
      "Experience with government contractors & tenders",
      "Understanding of public sector compliance needs",
      "Remote service — Pretoria, Centurion, Midrand & surrounds",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS compliance included",
    ],
  },
  {
    slug: "sandton",
    city: "Sandton",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Sandton | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Sandton businesses. Monthly bookkeeping, payroll, VAT & SARS compliance for the financial heart of Africa. SAICA registered, packages from R300/month.",
    heroTitle: "Bookkeeping Services in Sandton",
    heroDescription: "SAICA registered bookkeeping and SARS compliance for Sandton-based companies — from financial services in Sandton CBD to consultancies in Morningside.",
    intro: "Sandton is the financial capital of Africa, home to head offices, asset managers, law firms, and high-growth consultancies. Bookkeeping in Sandton has to keep pace with fast-moving deal cycles, multi-entity structures and demanding investor reporting.",
    localInsight: "We work with Sandton SMEs that want clean books, monthly management accounts, and full SARS/CIPC compliance without the overhead of an in-house finance team — fully remote, accurate, and on time.",
    whyLocal: [
      "Experience with professional services & financial firms",
      "Monthly management accounts ready for investors",
      "Remote service — no Sandton traffic, no office visits",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "centurion",
    city: "Centurion",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Centurion | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Centurion businesses. Monthly bookkeeping, payroll, SARS & CIPC compliance. SAICA registered, packages from R300/month.",
    heroTitle: "Bookkeeping Services in Centurion",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses across Centurion and the Pretoria-Johannesburg corridor.",
    intro: "Centurion sits at the heart of Gauteng's business corridor — a hub for IT, engineering, government suppliers and fast-growing SMEs. Reliable bookkeeping ensures Centurion businesses stay compliant while scaling.",
    localInsight: "We support Centurion business owners with clean monthly books, accurate VAT and payroll submissions, and on-time CIPC annual returns — all delivered remotely.",
    whyLocal: [
      "Experience with IT, engineering and government suppliers",
      "Reliable monthly close and reporting",
      "Remote service across Centurion and surrounds",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "umhlanga",
    city: "Umhlanga",
    province: "KwaZulu-Natal",
    metaTitle: "Bookkeeping Services Umhlanga | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Umhlanga businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered, packages from R300/month.",
    heroTitle: "Bookkeeping Services in Umhlanga",
    heroDescription: "SAICA registered bookkeeping and SARS compliance for businesses in Umhlanga, La Lucia and the KZN North Coast.",
    intro: "Umhlanga has become one of KZN's fastest-growing business nodes, home to corporate HQs, hospitality groups, and professional services. Accurate bookkeeping keeps Umhlanga's busy operators ahead of every SARS deadline.",
    localInsight: "From boutique hotels to medical practices, we deliver tidy monthly accounts, payroll, and compliance for Umhlanga businesses — without ever needing a site visit.",
    whyLocal: [
      "Experience with hospitality, medical and professional services",
      "Reliable VAT and payroll submissions",
      "Remote service across the KZN North Coast",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "gqeberha",
    city: "Gqeberha",
    province: "Eastern Cape",
    metaTitle: "Bookkeeping Services Gqeberha (Port Elizabeth) | From R300/m",
    metaDescription: "Professional bookkeeping for Gqeberha (Port Elizabeth) businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Gqeberha",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses across Gqeberha (Port Elizabeth) and the Eastern Cape.",
    intro: "Gqeberha is the Eastern Cape's industrial engine, anchored by automotive manufacturing, logistics and a strong SME base. Proper bookkeeping keeps EC businesses audit-ready and compliant.",
    localInsight: "We work with Gqeberha SMEs that need reliable monthly books and SARS submissions without the cost of a full-time bookkeeper.",
    whyLocal: [
      "Experience with manufacturing and supply-chain businesses",
      "Reliable monthly close and tax submissions",
      "Remote service across the Eastern Cape",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "east-london",
    city: "East London",
    province: "Eastern Cape",
    metaTitle: "Bookkeeping Services East London | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for East London businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered, packages from R300/month.",
    heroTitle: "Bookkeeping Services in East London",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses across East London and Buffalo City.",
    intro: "East London anchors Buffalo City's economy with automotive, logistics, agriculture and a growing services sector. Clean books and on-time SARS submissions are non-negotiable for Eastern Cape SMEs.",
    localInsight: "Our team supports East London businesses with monthly bookkeeping, payroll and full compliance — delivered remotely with no disruption to your operation.",
    whyLocal: [
      "Experience with EC manufacturing and services",
      "Reliable monthly bookkeeping and payroll",
      "Remote service across Buffalo City",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "bloemfontein",
    city: "Bloemfontein",
    province: "Free State",
    metaTitle: "Bookkeeping Services Bloemfontein | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Bloemfontein businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Bloemfontein",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses across Bloemfontein and the Free State.",
    intro: "Bloemfontein is the judicial capital and the commercial centre of the Free State, with strong agriculture, retail and professional-services sectors. Sound bookkeeping is the foundation for sustainable growth.",
    localInsight: "We handle bookkeeping, VAT, payroll and CIPC for Bloemfontein SMEs remotely — so owners can focus on their customers, not their compliance.",
    whyLocal: [
      "Experience with agriculture, retail and services",
      "Reliable monthly bookkeeping and payroll",
      "Remote service across the Free State",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "polokwane",
    city: "Polokwane",
    province: "Limpopo",
    metaTitle: "Bookkeeping Services Polokwane | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Polokwane businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Polokwane",
    heroDescription: "SAICA registered bookkeeping and SARS compliance for businesses across Polokwane and Limpopo province.",
    intro: "Polokwane is Limpopo's commercial hub, supporting retail, mining services, agriculture, and government contractors. Accurate books and timely SARS submissions protect your business from penalties.",
    localInsight: "Our remote team supports Polokwane SMEs with monthly bookkeeping, payroll and CIPC compliance — no office visits required.",
    whyLocal: [
      "Experience with retail, mining services and agriculture",
      "Reliable monthly close and tax submissions",
      "Remote service across Limpopo",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "mbombela",
    city: "Mbombela",
    province: "Mpumalanga",
    metaTitle: "Bookkeeping Services Mbombela (Nelspruit) | From R300/m",
    metaDescription: "Professional bookkeeping for Mbombela (Nelspruit) businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Mbombela",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses in Mbombela (Nelspruit) and across Mpumalanga.",
    intro: "Mbombela is Mpumalanga's economic centre — anchored by tourism, agriculture, mining services and a strong SME community. Clean monthly books make growth and funding possible.",
    localInsight: "We deliver remote bookkeeping, payroll and CIPC support to Mbombela businesses so owners stay focused on revenue, not paperwork.",
    whyLocal: [
      "Experience with tourism, agriculture and mining services",
      "Reliable monthly bookkeeping and payroll",
      "Remote service across Mpumalanga",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "stellenbosch",
    city: "Stellenbosch",
    province: "Western Cape",
    metaTitle: "Bookkeeping Services Stellenbosch | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Stellenbosch businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Stellenbosch",
    heroDescription: "SAICA registered bookkeeping and SARS compliance for businesses across Stellenbosch, the Winelands and Cape Winelands corridor.",
    intro: "Stellenbosch is home to wine estates, tech startups, and a thriving university-driven economy. Each industry brings its own bookkeeping requirements — and we handle them all.",
    localInsight: "From wine producers to tech SMEs, we deliver monthly books, payroll, VAT and CIPC compliance remotely — built for Stellenbosch's diverse business community.",
    whyLocal: [
      "Experience with wine estates, tech startups and tourism",
      "Reliable monthly close and reporting",
      "Remote service across the Winelands",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "randburg",
    city: "Randburg",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Randburg | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Randburg businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Randburg",
    heroDescription: "SAICA registered bookkeeping, payroll and SARS compliance for businesses across Randburg and the West Rand.",
    intro: "Randburg is a busy commercial node with SMEs spanning retail, professional services, media and trade. Reliable bookkeeping keeps owners compliant and in control of cash flow.",
    localInsight: "We support Randburg businesses with monthly accounts, payroll and full SARS/CIPC compliance — all delivered remotely so there's no disruption to your day.",
    whyLocal: [
      "Experience with Randburg and West Rand SMEs",
      "Reliable monthly bookkeeping and reporting",
      "Remote service — no traffic, no office visits",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
  {
    slug: "midrand",
    city: "Midrand",
    province: "Gauteng",
    metaTitle: "Bookkeeping Services Midrand | SAICA Registered | From R300/m",
    metaDescription: "Professional bookkeeping for Midrand businesses. Monthly bookkeeping, payroll, VAT & SARS compliance. SAICA registered.",
    heroTitle: "Bookkeeping Services in Midrand",
    heroDescription: "SAICA registered bookkeeping and SARS compliance for businesses across Midrand and the JHB-Pretoria corridor.",
    intro: "Midrand is one of Gauteng's fastest-growing business hubs — home to tech, logistics, construction and conferencing. Sound bookkeeping is the backbone of scaling here.",
    localInsight: "We deliver monthly books, payroll, VAT and CIPC compliance for Midrand SMEs — fully remote, on time, and audit-ready.",
    whyLocal: [
      "Experience with tech, logistics and construction",
      "Reliable monthly close and reporting",
      "Remote service across the JHB-Pretoria corridor",
      "SAICA registered professionals",
      "Packages from just R300/month",
      "Full SARS & CIPC compliance included",
    ],
  },
];

export function getLocationBySlug(slug: string): LocationData | undefined {
  return locations.find((l) => l.slug === slug);
}

// City slugs that get a public landing page at /bookkeeping-services-{slug}
export const citySlugs = locations.map((l) => l.slug);
